import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Card, CardActions, CardContent, Typography } from '@material-ui/core';
import cx from 'clsx';
import Mustache from 'mustache';
import { useState } from 'react';
import { renderSkill } from './Answer/Skill';
export function Questionnaire(_a) {
    var cardId = _a.cardId, messages = _a.messages, operatorEscalationUrl = _a.operatorEscalationUrl, skillApi = _a.skillApi, onFeedback = _a.onFeedback;
    var _b = useState('notSelected'), state = _b[0], setState = _b[1];
    var feedback = function (action) {
        onFeedback(action, function () { return setState(action); });
    };
    return (_jsxs(Card, { className: cx('faq-questionnaire', state), children: [_jsxs(CardContent, { children: [_jsx(Typography, { className: "faq-questionnaire__title", color: "textSecondary", align: "left", gutterBottom: true, component: "div", dangerouslySetInnerHTML: {
                            __html: Mustache.render(messages[state], { operatorEscalationUrl: operatorEscalationUrl }),
                        } }), state === 'yes'
                        ? renderSkill(skillApi, {
                            from: 'FAQ_FEEDBACK_YES',
                            text: messages.yesForm,
                            cardId: cardId,
                        })
                        : state === 'no'
                            ? renderSkill(skillApi, {
                                from: 'FAQ_FEEDBACK_NO',
                                text: messages.noForm,
                                cardId: cardId,
                            })
                            : null] }), state !== 'notSelected' ? null : (_jsxs(CardActions, { className: cx('faq-actions', 'faq-questionnaire__actions'), children: [_jsx(Button, { className: cx('faq-button', 'faq-questionnaire__actions__button'), variant: "contained", color: "secondary", size: "small", onClick: function () { return feedback('yes'); }, children: "\u306F\u3044" }), _jsx(Button, { className: cx('faq-button', 'faq-questionnaire__actions__button'), variant: "contained", color: "secondary", size: "small", onClick: function () { return feedback('no'); }, children: "\u3044\u3044\u3048" })] }))] }));
}
//# sourceMappingURL=Questionnaire.js.map